/**
 * 校验字符串是否为空
 * @param str 字符串
 * @returns {boolean}
 */
export function isStringEmpty(str) {
  return !str || str.trim() === '';
}

/**
 * 校验数组是否为空
 * @param arr 数组
 * @returns {boolean}
 */
export function isArrayEmpty(arr) {
  return !Array.isArray(arr) || arr.length === 0;
}
